import { Validatable, MultiInputSumModel, SimpleLookupModel, StrategyLookupModel } from "@/core/models";
import _ from "lodash";

export class QuestionnaireModel extends Validatable {
  id: number = (undefined as any);
  dateUpdated?: Date;
  step: number = -1;
  nextStep: number = -1;
  subStep: number = 0;
  showOnlyFirstStep: boolean = false;
  noOfEmployees: number = 0;
  companyCreationYear: number = new Date().getFullYear();
  goalsPast: MultiInputSumModel = new MultiInputSumModel();
  goalsPrediction: MultiInputSumModel = new MultiInputSumModel();
  turnoverExpectedId: number = (undefined as any);
  turnoverExportsId: number = (undefined as any);
  exportCountriesToday: number = 0;
  exportCountriesFuture: number = 0;
  productsLastYear: number = 0;
  productsFuture: number = 0;
  goal1: string = "";
  goal2: string = "";
  goal3: string = "";
  goal4: string = "";
  ksf1: string = "";
  ksf2: string = "";
  ksf3: string = "";
  ksf4: string = "";
  strategicPriority1: string = "";
  strategicPriority2: string = "";
  strategicPriority3: string = "";
  strategicPriority4: string = "";
  strategicCapability1: string = "";
  strategicCapability2: string = "";
  strategicCapability3: string = "";
  strategicCapability4: string = "";
  criticalSkills: CriticalSkillModel[] = [];
  gateways: QuestionnaireGatewayModel[] = [];
  checkedOutById?: number;
  checkedOutDate?: Date;
  checkedOutByName: string = "";
  isOpen: boolean = false;

  constructor(data?: Partial<QuestionnaireModel>) {
    super();

    // Backend is now in charge of creating these objects
    this.goalsPast = {} as any;
    this.goalsPrediction = {} as any;

    if (data) {
      Object.assign(this, data);
    }
  }
}

export class CriticalSkillModel {
  id: number = (undefined as any);
  name: string = "";
  capabilities: CapabilityRatingItemModel[] = [];
  skillAmounts1: Array<undefined | number> = [, 0, 0, 0, 0, 0];
  strategies1: SkillsStrategyModel[] = [];
  skillAmounts2: Array<undefined | number> = [, 0, 0, 0, 0, 0];
  strategies2: SkillsStrategyModel[] = [];
  assumption1: string = "";
  assumption2: string = "";
  assumption3: string = "";
  help1: string = "";
  help2: string = "";
  help3: string = "";
  skillMatchId: number = (undefined as any);

  constructor(data?: Partial<CriticalSkillModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class QuestionnaireGatewayModel extends Validatable {
  gatewayId: number = 0;
  identifier: string = "";
  percentage: number | null | undefined = null;
  comments: string = "";

  constructor(data?: Partial<QuestionnaireGatewayModel>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class CapabilityRatingItemModel {
  id: number = (undefined as any);
  identifier: string = "";
  text: string = "";
  isSelected = false;
  sortOrder?: number;

  constructor(data?: Partial<CapabilityRatingItemModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class SkillsStrategyModel {
  id: number = (undefined as any);
  strategyTypeId: number = (undefined as any);
  strategyId: number = (undefined as any);
  strategyLevelId: number = (undefined as any);
  isSelected = false;
}

export class QuestionnaireLookups {
  counties: SimpleLookupModel[] = [];
  turnover: SimpleLookupModel[] = [];
  strategies: StrategyLookupModel[] = [];
  strategyTypes: SimpleLookupModel[] = [];
  strategyLevels: SimpleLookupModel[] = [];
  skillMatches: SimpleLookupModel[] = [];
}

export class SkillMatchLookups {
  skillMatchPillars: SimpleLookupModel[] = [];
  skillMatchTypes: SimpleLookupModel[] = [];
}

// Internal models
export class AddSkillMatchModel extends Validatable {
  text: string = "";
  skillMatchPillarId: number = null as any;
  skillMatchTypeId: number = null as any;
}

export class StrategyGridModel {
  rows: StrategyGridRowModel[] = [];
}

export class StrategyGridRowModel {
  rowText: string = "";
  strategies: undefined | SkillsStrategyModel[];
}

export class QuestionnaireStatusModel {
  id: number;
  dateCompleted: Date;
  completedById?: number;
  completedByName: string;
  comments: string;
  isOpen: boolean;
  [key: string]: any;
}
